import React, { Component } from "react";
import { Button, Form, Image, } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import "./Abha.css";
import Aadhaar from "./Aadhaar.png";
import mobile from "./mobile.png";
import ReCAPTCHA from 'react-google-recaptcha';

export default class AbhaVerification extends Component {
  constructor(props) {
    super(props);
       this.recaptchaRef = React.createRef();
    
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      aadharNumber: sessionStorage.getItem("aadhaarNumber"),
      abhaotp: ["", "", "", "", "", ""],
      AbhaProfile: {},
      abhanumber: ["", "", "", ""],
      mobile: "",
      showOtp: false,
      showAbha: false,
      cabhaaddress: "",
      custshowAddess: false,
      isAbhaVerifiedReady: false,
      authMethods: "",
      resendTimer: 60, // 1 minutes
      resendEnabled: false,
      resendIntervalId: null,
      captchaToken: null,

      // ["AADHAAR_OTP", "MOBILE_OTP"]
    };
  }
  handleCaptchaChange = (value) => {
    this.setState({
      captchaToken: value,
    });
  };
  resetCaptcha = () => {
    this.setState({ captchaToken: "" });
    if (this.recaptchaRef && this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };
  startResendCountdown = () => {
    this.setState({
      resendEnabled: false,
      resendOtpANCount:  parseInt(sessionStorage.getItem("resendOtpANCount")) || 0,
      resendTimer: 60,
    });
    const intervalId = setInterval(() => {
      this.setState((prevState) => {  
        if (prevState.resendTimer <= 1) {
          clearInterval(this.state.resendIntervalId);
          return { resendEnabled: true, resendTimer: 0 };
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
    this.setState({ resendIntervalId: intervalId });
  };
  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  ResendOTP = (e) => {
    e.preventDefault();
    let resendCount = parseInt(sessionStorage.getItem("resendOtpANCount")) || 0;
    if (resendCount >= 2) {
      this.showToast("Maximum resend attempts reached.", "error");
      return;
    }
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhadetails/resendAbhaOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        const isValid =
        data.status === "success" &&
        data.requestId && data.requestId !== 0 &&
        (!data.details || !data.details[0]?.message?.includes("Invalid"));

      if (isValid) {
        resendCount++;
        sessionStorage.setItem("resendOtpANCount", resendCount);
        this.showToast("OTP resent successfully!", "success");
        clearInterval(this.state.resendIntervalId);
        this.startResendCountdown();
      } else {
        const errorMsg = data?.detail?.[0]?.message||data.message || "OTP resend failed. Please try again.";
         this.showToast(errorMsg);
      }
    })
   
  };
  componentDidMount() {
    this.ResponseHandler();

    const abhanumberRaw = sessionStorage.getItem("abhanumber");
    if (abhanumberRaw) {
      const abhaPlain = abhanumberRaw.replace(/-/g, ""); // Remove dashes
      if (abhaPlain.length === 14) {
        const abhaSplit = [
          abhaPlain.slice(0, 2),
          abhaPlain.slice(2, 6),
          abhaPlain.slice(6, 10),
          abhaPlain.slice(10, 14),
        ];
        this.setState({ abhanumber: abhaSplit });
      }
    }
    if (!sessionStorage.getItem("resendOtpANCount")) {
      sessionStorage.setItem("resendOtpANCount", "0");
    }
    this.startResendCountdown();
  }
  ResponseHandler = () => {
    var formData = new FormData();

    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail && data.detail.abhaprofile ) {
          const abhaDetails = JSON.parse(data.detail.abhaprofile);
          // console.log(abhaDetails);
          const abhaProfile = abhaDetails.ABHAProfile;
          //  const abhanumber = data.detail.abhanumber;

          if (abhaProfile)
            this.setState({
              AbhaProfile: abhaProfile,
              abhanumber: this.state.abhanumber,
            });
          else {
            window.location = "/consent";
          }
        }
      });
  };  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.success(msg);
    }
  };

  handleabhaIdChange = (index, value) => {
    const updated = [...this.state.abhanumber];
    const limit = index === 0 ? 2 : 4;
    updated[index] = value.replace(/\D/g, "").slice(0, limit);
    this.setState({ abhanumber: updated });
  };

  handleabhaotpChange = (e, index) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      // allow only single digit or empty
      this.setState(
        (prevState) => {
          const newOtp = [...prevState.abhaotp];
          newOtp[index] = val;
          return { abhaotp: newOtp };
        },
        () => {
          // auto focus next input if a digit was entered
          if (val && index < 5) {
            this[`otpInput${index + 1}`].focus();
          }
        }
      );
    }
  };
  handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !this.state.abhaotp[index] && index > 0) {
      this[`otpInput${index - 1}`].focus();
    }
  };

  handleSubmitNext = (e) => {
    e.preventDefault();
  
    const { abhanumber, authMethods ,captchaToken} = this.state;
    const fullabhanumber = `${abhanumber[0]}-${abhanumber[1]}-${abhanumber[2]}-${abhanumber[3]}`;
    const abhaPlain = abhanumber.join("");
    const abhaRegex = /^\d{14}$/;
  
    if (!abhaRegex.test(abhaPlain)) {
       this.showToast("ABHA number must be exactly 14 digits."); // Error: Use  this.showToast
      return;
    }
    if (!captchaToken) {
       this.showToast('Please verify that you are not a robot!',"error");
      return;
    }
    sessionStorage.setItem("abhanumber", abhanumber.join("-"));
  
    const formData = new FormData();
    formData.append("abhanumber", fullabhanumber);
    formData.append("authMethods", authMethods);
    formData.append("captchaToken", captchaToken);

    formData.append("requestId", sessionStorage.getItem("requestId"));
  
    fetch(configData.api_url + "C_Abhadetails/submitAbhaNumber", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, "success");
          sessionStorage.setItem("message", data.details.message);
          sessionStorage.setItem("resendOtpANCount", "");
          
          this.setState({
            responseMessage: data.details.message,
            message: data.message,
            showMessage: true,
          });
  
          setTimeout(() => {
            window.location.href = "/abhaverificationnumberOtp";
          }, 1500);
        } else {
          const errorMsg = data.message || "Something Went Wrong";
           this.showToast(errorMsg);
        }
      })
      .catch((err) => {
         this.showToast("Network error or server not responding");
        console.error("Submit ABHA Error:", err);
      });
  };
  
  handleSubmitOTPNext = (e) => {
    e.preventDefault();
    const { abhanumber, aadharNumber ,  captchaToken} = this.state;
    const abhaotp = this.state.abhaotp.join("");
    if (!captchaToken) {
       this.showToast('Please verify that you are not a robot!',"error");
      return;
    }
    sessionStorage.setItem("abhaotp", this.state.abhaotp);
    var formData = new FormData();

    formData.append("abhaotp", abhaotp);
    formData.append("captchaToken", captchaToken);

    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitAbhaOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          sessionStorage.setItem("aadharNumber", aadharNumber);
          sessionStorage.setItem("resendOtpANCount", "");
          sessionStorage.setItem("abhanumber", abhanumber.join("-"));
          
          sessionStorage.setItem("abhanumberrequestId", data.detail.requestId);
          window.location.href = "/abhaaddressverification";

          this.setState({
            resendOtpANCount: "",
          });
          if (this.recaptchaRef && this.recaptchaRef.current) {
            this.recaptchaRef.current.reset(); // ✅ Reset after submission
          }
        }
        else {
          // Custom message for specific backend error key
          if (data.details?.loginId === "Invalid LoginId") {
             this.showToast("LNo ABHA user registered with this Aadhaar number..");
          } else {
            // Generic fallback
            const errorMessage = data.details?.message || data.message || "Something went wrong.";
             this.showToast(errorMessage);
          }
        }
  
        this.setState({
          aadhaarNumber: "",
          isSubmitting: false,
        });
  
        if (this.recaptchaRef && this.recaptchaRef.current) {
          this.recaptchaRef.current.reset(); // Reset ReCAPTCHA
        }
      })
      .catch((error) => {
        console.error("API error:", error);
         this.showToast("An unexpected error occurred. Please try again later.");
        this.setState({ isSubmitting: false });
      });
  };
     

  toggleOtpVisibility = () => {
    this.setState((prevState) => ({ showOtp: !prevState.showOtp }));
  };

  HandleClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };

  HandleShareClickClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };

  HandleQRCodeClickClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };
handleDownloadPng = async (url) => {
 
  try {
    
    const requestId = sessionStorage.getItem("requestId") || "file";

    // Fetch file as blob
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network response was not ok");

    const blob = await response.blob();

    // Create temporary URL
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    // Preserve file extension from blob type
    const ext = blob.type.split("/")[1] || "png"; // fallback
    link.download = `${requestId}.${ext}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Release memory
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download failed:", error);
  }
};
  HandleNextSubmit = () => {
    window.location.href = "/abhaprofile";
  };
  HandleNewClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber.join("-"));
    // sessionStorage.setItem("abhaAddress", abhaAddress);

    window.location.href = "/abhaaddresscreation";
  };

  handleImageClick = (option) => {
    this.setState({ authMethods: option });
  };
  handleSubmitBack=()=>{
    window.location.href ="./Abharegister"
  }
  render() {
    const {
      abhanumber,
      showAbha,
      authMethods,
      
    } = this.state;
    return (
      <div>
               {/* <div className="row mb-2" id="flowStyle">
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-collection nav-icon">
              <p className="nav-label mt-2">Consent Collection</p>
            </div>
          </div>

          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">Mobile Authentication</p>
            </div>
          </div>
          <div className="col-md-3 flowTab active-page">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">ABHA verification</p>
            </div>
          </div>
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Profile Collection</p>
            </div>
          </div>
               </div> */}
        <div className="row justify-content-md-center text-center abhaverification">
    
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>
                  <b>ABHA Number</b>
                </Form.Label>
                <br />
                {/* {abhanumber} */}
                <div className="d-flex gap-2">
                  {abhanumber.map((val, idx) => (
                    <Form.Control
                      className="otp-input-box"
                      key={idx}
                      tabIdx={idx + 1}
                      id={`abhanumber-${idx}`}
                      type={showAbha ? "text" : "password"}
                      value={val}
                      onChange={(e) =>
                        this.handleabhaIdChange(idx, e.target.value)
                      }
                      maxLength={idx === 0 ? 2 : 4}
                      placeholder={idx === 0 ? "XX" : "XXXX"}
                    />
                  ))}
                  <Button
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      this.state.showAbha ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={() => this.setState({ showAbha: !showAbha })}
                  />
                </div>
                <br />
                <div className="row justify-content-md-center selectAadhaarMobileOtp">
                  <p>Validate using</p>

                  <div className="col text-center">
                    <div
                      onClick={() => this.handleImageClick("aadhaarotp")}
                      style={{
                        border:
                          authMethods === "aadhaarotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={Aadhaar}
                        className=""
                        alt="Aadhaar"
                        style={{
                          width: "auto",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Aadhaar OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "aadhaarotp"}
                      />
                    </div>
                  </div>

                  <div className="col text-center">
                    <div
                      onClick={() => this.handleImageClick("mobileotp")}
                      style={{
                        border:
                          authMethods === "mobileotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={mobile}
                        className="navbar-brand pe-3 ps-4 ps-lg-2"
                        alt="Mobile"
                        style={{
                          width: "auto",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Mobile OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "mobileotp"}
                      />
                    </div>
                  </div>
                </div>

              
              </Form.Group>
                  <div className="d-flex">   
                        <ReCAPTCHA 
                          className="mt-4"
                          ref={this.recaptchaRef} 
                          sitekey= {configData.captchaKey}
                          onChange={this.handleCaptchaChange}
                        /> 
                      <Button variant="secondary"  
                      className="bi bi-arrow-clockwise re-chaptue" 
                        onClick={() => this.recaptchaRef.current.reset()}/>
                </div>
          
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
        <div className="col text-start">
               <Button
                  className="rounded-0 m-3"
                  onClick={this.handleSubmitBack}
                >
                Back
                </Button>
          </div>
        
          <div className="col text-end">
               <Button
                  className="rounded-0 m-3"
                  onClick={this.handleSubmitNext}
                >
                  Verify ABHA Number
                </Button>
          </div>
        </div>
      </div>
    );
  }
}
